export default "__VITE_ASSET__639a2337__"